import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class InputValidationService {
  preventForbiddenCharacters(
    event: Event,
    type: 'number' | 'text' | 'email' | 'tel'
  ): void {
    const inputElement = event.target as HTMLInputElement;
    let val: string | number = inputElement.value;
    const isInvalidNumber = (value: number) =>
      isNaN(value) || value < (type === 'number' ? 1 : 0);

    if (type === 'number' || type === 'tel') {
      val = Number(inputElement.value);
      if (isInvalidNumber(val)) {
        inputElement.value = '';
        return;
      }
    } else if (type === 'text') {
      if (/^[\s]|[^a-zA-ZğüşıöçĞÜŞİÖÇ\s]/.test(val)) {
        inputElement.value = val.replace(/^[\s]+|[^a-zA-ZğüşıöçĞÜŞİÖÇ\s]/g, '');
      }
      if (inputElement.value.trim() === '') {
        inputElement.value = '';
      }
    } else if (type === 'email') {
      if (/^[\s]|[^a-zA-Z0-9@._]/.test(val)) {
        inputElement.value = val.replace(/^[\s]+|[^a-zA-Z0-9@._]/g, '');
      }
      if (inputElement.value.trim() === '') {
        inputElement.value = '';
      }
    }
  }
}
